import React from 'react'

interface Props {
  beats: number
  color: string
  label: string
  total: number
}

export default function EstimateBeat({ beats, color, label, total }: Props) {
  const percent = ((beats / total) * 100).toFixed(0)
  return (
    <div className="flex text-muted">
      <div className="pr-3 text-2xl font-bold" style={{ color: color }}>
        {percent}%
      </div>
      <div className="text-2xs text-muted">
        <div>
          <span className="font-bold">{label}</span> beats the estimate
        </div>
        <div>
          <span className="font-bold">
            {beats}/{total}
          </span>{' '}
          last quarters
        </div>
      </div>
    </div>
  )
}
